import axios from "./axiosInstance";
import { Globals } from "../global/Globals";
import CryptoUtils from "../util/cryptoUtils";

export const fetchAllLanguages = async () => {
    const apiResponse = await axios.get(Globals.ENDPOINT.ALL_LANGUAGES);
    return apiResponse;
}

export const fetchAllGenres = async () => {
    const apiResponse = await axios.get(Globals.ENDPOINT.ALL_GENRES);
    return apiResponse;
}
export const fetchAllRoles  = async() =>{
    const apiResponse=await axios.get(Globals.ENDPOINT.All_ROLES);
return apiResponse;
}

export const fetchAllChannels = async () => {
    const apiResponse = await axios.get(Globals.ENDPOINT.ALL_CHANNELS);
    return apiResponse;
}

export const fetchChannelsByCountry = async (countryId) => {
    const apiResponse = await axios.get(Globals.ENDPOINT.CHANNELS_BY_COUNTRY+countryId);
    return apiResponse;
}

export const fetchScriptTypesByCountry = async (countryId) => {
    const apiResponse = await axios.get(Globals.ENDPOINT.SCRIPT_TYPES_BY_COUNTRY+countryId);
    return apiResponse;
}

export const fetchClustersByCountryAndScript = async (countryId,scriptId) => {
    const apiResponse = await axios.get(Globals.ENDPOINT.CLUSTER_BY_COUNTRY_AND_SCRIPT+countryId+"/"+scriptId);
    return apiResponse;
}

export const fetchLanguagesByChannel = async (channelId) => {
    const apiResponse = await axios.get(Globals.ENDPOINT.LANGUAGES_BY_CHANNEL+channelId);
    return apiResponse;
}

export const fetchGenresByCluster = async (clusterId) => {
    const apiResponse = await axios.get(Globals.ENDPOINT.GENRES_BY_CLUSTER+clusterId);
    return apiResponse;
}

export const fetchAllCountries = async () => {
    const apiResponse = await axios.get(Globals.ENDPOINT.ALL_COUNTRIES);
    return apiResponse;
}

export const fetchAllRegions = async () => {
    const endpoint = Globals.BASE_URL + Globals.ENDPOINT.ALL_REGIONS;
    const apiResponse = await axios.get(endpoint);
    return apiResponse;
}

export const fetchAllFormats = async () => {
    const endpoint = Globals.BASE_URL + Globals.ENDPOINT.ALL_FORMATS;
    const apiResponse = await axios.get(endpoint);
    //const apiResponse=[];
    return apiResponse;
}

export const fetchProvienceByCountry = async (countryList, countryName) => {
    const countryDetails = countryList.find(country => country.countryName === countryName);
    const countryId=countryDetails ? countryDetails.countryId : null; 
    const apiResponse = await axios.get(Globals.ENDPOINT.PROVIENCE + countryId);
    return apiResponse;
}

export const fetchEmail=async(userEmail)=>{
const apiResponse=await axios.get(Globals.ENDPOINT.EAMIL_EXIST+userEmail);
return apiResponse;
}

export const fetchUserEmail = async (userEmail) => {
  const apiResponse = await axios.get(
    Globals.ENDPOINT.USER_EMAIL_EXISTS + userEmail
  );
  return apiResponse;
};

export const fetchByfilter = async (filterName) => {
    const channels=[filterName];
    const config = {
        headers: {
          'Content-Type': 'application/json' // Set the Content-Type header
        }
      };
    const endpoint = Globals.BASE_URL + Globals.ENDPOINT.FILTER_BY;
   const apiResponse = await axios.post(Globals.ENDPOINT.FILTER_BY,channels,config);
    return apiResponse;
}

export const fetchChannelbyClusters = async (filterName,cluster) => {
    const channels=[filterName];
    const config = {
        headers: {
          'Content-Type': 'application/json' // Set the Content-Type header
        }
      };
    const endpoint = Globals.BASE_URL + Globals.ENDPOINT.FETCH_CHANNEL_BY_CLUSTER + cluster +"?isusingDashboard=true";
    const apiResponse = await axios.get(endpoint);
    return apiResponse;
}



export const getUserListsByRoleIdsAndClusterId = async (roleIds, clusterId) => {
    const endpoint = `${Globals.BASE_URL}${Globals.ENDPOINT.FILTER_BY_CREATEDBY}?roleIds=${roleIds}${clusterId ? `&clusterId=${clusterId}`: ''}`;
    const apiResponse = await axios.get(endpoint);
    return apiResponse;
}

//This API is to validate all mandatory fields on the registration page
export const validateProducerMandatoryFields = async (fieldName, fieldValue) => {
    try {
        const body =
        {
            "key": fieldName,
            "value": fieldValue
        }
        const config = {
            headers: {
                'Content-Type': 'application/json' // Set the Content-Type header
            }
        };
        const apiResponse = await axios.post(Globals.ENDPOINT.VALIDATE_PRODUCER_MANDATORY_FIELDS, body, config)
        const res = apiResponse.data.Exists
        return res;
    } catch (error) {
        if (error.response.status === 404 || error.response.status === '404') {
            return false;//!error?.response?.data?.Exists;
        } else {
            return true;
        }
    }
}

//Logout user
export const logoutUser = async () => {
    const config = {
        headers: {
            'Content-Type': 'application/json' // Set the Content-Type header
        }
    };
    const apiResponse = await axios.post(Globals.ENDPOINT.LOGOUT, config);
    return apiResponse;
}


export const downloadFile = async (filePath, isForProducer=false) => {
    let apiResponse;
    const config={
        header:{'Content-Type':'application/octet-stream'},
        responseType: 'arraybuffer'
    };
    if(!isForProducer){
        apiResponse = await axios.get(Globals.ENDPOINT.FILE_DOWNLOAD + filePath,config);//filePath);
    }
    else{
        apiResponse = await axios.get(Globals.ENDPOINT.PRODUCER_FILE_DOWNLOAD + filePath, config);
    }
    return apiResponse;
}
export const fetchAllProduction = async () => {
    const apiResponse = await axios.get(Globals.ENDPOINT.PRODUCTION_TYPE);
    return apiResponse;
}

export const DownloadProposalPdf= async (proposalId,proposalDetailId,Type) =>{
    const config={
        header:{'Accept': 'application/pdf'
    }};
    const Endpoint = Type === "Unsolicited" ? Globals.ENDPOINT.DOWNLOADUNSOLICITEDPDF : Globals.ENDPOINT.DOWNLOADSOLICITEDPDF ;
    const FinalEndpoint = Endpoint +"proposalId="+proposalId+"&proposalDetailId="+proposalDetailId;
    const apiResponse=await axios.get(FinalEndpoint,config);
    return apiResponse;
}
export const DownloadProposalWord = async (proposalId,proposalDetailId,Type) =>{
    const config={
        header:{'Accept': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    }};
    const Endpoint = Type === "Unsolicited" ? Globals.ENDPOINT.DOWNLOADUNSOLICITEDWORD : Globals.ENDPOINT.DOWNLOADSOLICITEDWORD ;
    const FinalEndpoint = Endpoint+"proposalId="+proposalId+"&proposalDetailId="+proposalDetailId;
    const apiResponse=await axios.get(FinalEndpoint,config);
    return apiResponse;
}

export const DownloadBriefPdf= async (proposalId) =>{
    const config={
        header:{'Accept': 'application/pdf'
    }};
    const Endpoint = Globals.ENDPOINT.DOWNLOADBRIEFPDF;
    const FinalEndpoint = Endpoint +"proposalId="+proposalId;
    const apiResponse=await axios.get(FinalEndpoint,config);
    return apiResponse;
}
export const DownloadBriefWord = async (proposalId) =>{
    const config={
        header:{'Accept': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    }};
    const Endpoint = Globals.ENDPOINT.DOWNLOADBRIEFWORD;
    const FinalEndpoint = Endpoint+"proposalId="+proposalId;
    const apiResponse=await axios.get(FinalEndpoint,config);
    return apiResponse;
}
export const setConsent = async () => {
    const apiResponse = await axios.put(Globals.ENDPOINT.SETCONSENT);
    CryptoUtils.saveToLocalStorage("isConsent",true);
}

export const DownloadBriefExcel  = async (proposalId) =>{
    const config={
        header:{'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }};
    const Endpoint = Globals.ENDPOINT.BRIEFEXCELDOWNLOAD;
    const FinalEndpoint = Endpoint+"proposalId="+proposalId;
    const apiResponse=await axios.get(FinalEndpoint,config);
    return apiResponse;
}

export const updateCEEvalList=async(requestBody)=>{
    const apiResponse=await axios.put(Globals.ENDPOINT.UPDATE_CE_EVAL_LIST+CryptoUtils.getFromLocalStorage('roleId'),requestBody);
    return apiResponse;
}

export const ticketDetailsByTicketId = async (ticketId) => {
    const endpoint = `${Globals.ENDPOINT.TICKETDETAILS_TICKETID}${ticketId}`;
    const apiResponse = await axios.get(endpoint, Globals.CONFIG);
    return apiResponse;
}